import React, { useContext } from "react";
import Container from "../../components/ui/Container";
import SubjectContext from "../../context/SubjectContext";
import SubjectInfoSection from "../../sections/course/SubjectInfoSection";
import Categorie from "../../sections/home/CoursesSection/Categorie";
import SubscriptionInstructionComponent from "./SubscriptionInstructionComponent";
import TeachersGrid from "../../sections/home/CoursesSection/TeachersGrid";
import { isSubscribeBySubjectTeacher } from "../../services/defaultSettings";
import CoursesWithCategories from "../../sections/home/CoursesSection/CoursesWithCategories";

const SubjectHome = () => {
    const { subject } = useContext(SubjectContext);

    const subjectInfo = subject ? subject?.name.split(" ") : [""];
    return (
        <Container className="relative pt-10 md:pt-20">
            <CoursesWithCategories
                titleFirst={subjectInfo[0] || ""}
                titleLast={subjectInfo.length > 1 ? subjectInfo.slice(1).join(" ") : ""}
                api={`/api/subjects/${subject.id}/courses`}
            />
        </Container>
    );
};

export default SubjectHome;
